function decodeLineSsoPayload(payload) {
  if (!payload) {
    return null;
  }

  try {
    const normalizedPayload = String(payload).replaceAll('-', '+').replaceAll('_', '/');
    const paddedPayload = normalizedPayload + '='.repeat((4 - normalizedPayload.length % 4) % 4);
    return JSON.parse(decodeURIComponent(atob(paddedPayload)));
  } catch (err) {
    console.error('Invalid LINE SSO payload:', err);
    return null;
  }
}

export function seedLineSsoSnippetStorage(parameterURL, Cookies) {
  const user = decodeLineSsoPayload(parameterURL ? parameterURL.linesso : null);
  if (!user?.token) {
    return false;
  }

  [
    ['token_Snippet', user.token],
    ['username_Snippet', user.username],
    ['email_Snippet', user.email],
    ['isSnippet', true],
  ].forEach(([key, value]) => {
    localStorage.setItem(key, value);
    Cookies.set(key, value);
    sessionStorage.setItem(key, value);
  });
  return true;
}

export function clearLineSsoSnippetStorage(Cookies) {
  ['token_Snippet', 'username_Snippet', 'email_Snippet', 'isSnippet'].forEach((key) => {
    sessionStorage.removeItem(key);
    localStorage.removeItem(key);
    Cookies.remove(key);
  });
  localStorage.removeItem('lineSSOReturnUrl');
}

export function getQueryWithoutLineSso(query) {
  return Object.keys(query || {}).reduce((nextQuery, key) => {
    if (key.toLowerCase() !== 'linesso') {
      nextQuery[key] = query[key];
    }
    return nextQuery;
  }, {});
}
